import { render } from "./QuestionnaireCover.vue?vue&type=template&id=9d704be2&scoped=true&ts=true"
import script from "./QuestionnaireCover.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireCover.vue?vue&type=script&lang=ts"

import "./QuestionnaireCover.vue?vue&type=style&index=0&id=9d704be2&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d704be2"]])

export default __exports__